import React, { Component } from "react";
import PropTypes from "prop-types";

class AutoBindComponent extends Component {
	constructor(props, context, checkUnsavedChanges) {
		super();

		this.checkUnsavedChanges = checkUnsavedChanges;

		const handlerNames = this.getAllPropertyNames(this).filter(name => name.match(/^handleOn[A-Z]/));
		handlerNames.forEach(handlerName => this[handlerName] = this[handlerName].bind(this));
	}

	componentDidMount() {
		if (this.checkUnsavedChanges) {
			const message = 'Het huidig formulier-gedeelte bevat nog niet bewaarde wijzigingen. Ben je zeker dat je wil verder gaan, en de wijzigingen verliest?';
			this.unblockRouter = this.props.history.block(() => {
				if (this.state.hasUnsavedChanges)
					return message + "$true";
			});
		}
	}

	componentWillUnmount() {
		if (this.checkUnsavedChanges) {
			this.unblockRouter();
		}
	}

	getAllPropertyNames(object) {
		const prototype = Object.getPrototypeOf(object);
		const ownPropertyNames = Object.getOwnPropertyNames(object);
		return prototype ? ownPropertyNames.concat(this.getAllPropertyNames(prototype)) : ownPropertyNames;
	}
}

AutoBindComponent.propTypes = {
	history: PropTypes.object
};

export default AutoBindComponent;
